import React, { useState } from "react";
import { assetIcons } from "../../../constants/assets";
import { useTheme } from "../../../providers/theme-provider";
import { motion, AnimatePresence } from "framer-motion";
import useSmoothScroll from "../../../hooks/use-smooth-scroll";
import { useTranslation } from "react-i18next";
import { fontSizes } from "../../../theme/font-sizes";
import CtaButton from "../../buttons/cta-button/cta-button";

const NavbarSmall = ({ isScrolled }) => {
  const handleScroll = useSmoothScroll();
  const { colors, isDarkMode, toggleTheme } = useTheme();
  const { t } = useTranslation();

  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const navItems = [
    { label: t("navbar.navItems.home"), sectionId: "home" },
    { label: t("navbar.navItems.services"), sectionId: "services" },
    {
      label: t("navbar.navItems.testimonials"),
      sectionId: "testimonials-small",
    },
    { label: t("navbar.navItems.contact"), sectionId: "contact-small" },
  ];

  // Determine the appropriate image for the theme toggle button
  const themeToggleIcon = isDarkMode
    ? assetIcons.bulbDark
    : assetIcons.bulbLight;

  return (
    <>
      <motion.div
        className={`flex justify-between items-center gap-2 w-full transition-all duration-300 md:py-8 py-4 `}
        style={{
          backgroundColor: isScrolled ? colors.heroBg : "transparent",
          color: colors.textColor,
          maxWidth: isScrolled ? "95%" : "100%", // Adding some spacing for small screens
        }}
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 1 }}
      >
        <div onClick={() => handleScroll("home")}>
          <img
            src="/logo.png"
            alt=""
            className="cursor-pointer w-32"
            onClick={() => handleScroll("home")}
          />
        </div>

        <div className="flex-shrink-0">
          <button onClick={toggleMenu}>
            <img src={assetIcons.menu} alt="" className="w-6" />
          </button>
        </div>
      </motion.div>

      <AnimatePresence>
        {isMenuOpen && (
          <motion.div
            className="fixed inset-0 bg-white/80 backdrop-blur-[4px] z-50 flex flex-col px-6 py-4 h-[60vh] shadow-md"
            initial={{ opacity: 0 }}
            animate={{ opacity: 100 }}
            exit={{ opacity: 0 }}
            transition={{ type: "tween", duration: 0.3, ease: "easeInOut" }}
          >
            <div className="flex justify-between items-center mb-8 relative z-50">
              <img src="/logo.png" alt="Logo" className="w-32" />
              <button onClick={toggleMenu} className="p-2">
                <img src={assetIcons.cross} alt="" className="w-6" />
              </button>
            </div>

            <nav className="flex flex-col gap-6 text-lg relative z-50">
              {navItems.map((item, index) => (
                <li
                  className="hover:opacity-70 transition-opacity list-none"
                  style={{
                    fontSize: fontSizes.body,
                  }}
                  onClick={() => {
                    handleScroll(item.sectionId);
                    toggleMenu();
                  }}
                >
                  {item.label}
                </li>
              ))}
            </nav>

            {/* <button
              className="mt-auto mb-8 bg-black text-white py-3 px-6 rounded hover:bg-opacity-90 transition-opacity"
              onClick={toggleMenu}
            >
              Get a Quote
            </button> */}
            <div className="flex gap-2 mt-10">
              <CtaButton
                label={t("navbar.ctaButton")}
                onClick={() => {
                  handleScroll("contact-small");
                  setIsMenuOpen(false);
                }}
                style={{
                  marginTop: "auto",
                  marginBottom: 32,
                  width: "60%",
                  paddingTop: "14px",
                  paddingBottom: "14px",
                }}
              />
              <div
                className="xl:p-4 p-4 rounded-sm cursor-pointer mt-auto mb-8"
                style={{
                  backgroundColor: colors.themeToggle,
                }}
                onClick={toggleTheme}
              >
                <img src={themeToggleIcon} alt="" />
              </div>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
};

export default NavbarSmall;
